// extracted by mini-css-extract-plugin
module.exports = {"timerGreen":"Timer_timerGreen__3vbFR","timerRed":"Timer_timerRed__7kIWN"};